import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { catalogBibShape, ugcVideoShape } from '@bibliocommons/bc-prop-types';

import { selectVideosForCurrentBib, selectUgcSummary } from 'app/selectors/bibs/UgcSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import BibsActions from 'app/actions/BibsActions';
import { selectCurrentUserVideos, selectVideosTransactions } from 'app/selectors/ugc/VideosSelector';
import { ugcSummaryShape } from 'app/shapes/bibPage';
import Videos from './Videos';

export function VideosContainer(props) {
  return <Videos {...props} />;
}

VideosContainer.propTypes = {
  videos: ImmutablePropTypes.list.isRequired,
  currentUserVideos: ImmutablePropTypes.mapOf(ugcVideoShape).isRequired,
  videosTransactions: ImmutablePropTypes.map.isRequired,
  summary: ugcSummaryShape,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  catalogBib: catalogBibShape.isRequired
};

const mapStateToProps = state => ({
  videos: selectVideosForCurrentBib(state),
  currentUserVideos: selectCurrentUserVideos(state),
  videosTransactions: selectVideosTransactions(state),
  summary: selectUgcSummary(state),
  catalogBib: selectCatalogBib(state)
});

const mapDispatchToProps = dispatch => ({
  bibsActions: bindActionCreators(BibsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(VideosContainer);
